// Antar att grund-path är "/app/"
export const PAGE_URLS = {
    HOME: "/",
    SEARCH: "/sok",
    SAVED: "/sparade",
    PROFILE: "/profile",
    MAP: "/map",
    MATCH_GAME: "/matchgame",
}
